import type { AccessState } from './access.js';

/** Предварительное окончание оплаченного срока — по правилам billing.addMonths. */
export function proPeriodEnd(access: Pick<AccessState, 'tier' | 'endsAt'>, months: 1 | 3 | 6 | 12, now = new Date()): Date {
  const end = access.endsAt ? new Date(access.endsAt) : null;
  const from = access.tier === 'pro' && end && end > now ? end : now;
  const until = new Date(from);
  const day = until.getUTCDate();
  until.setUTCDate(1);
  until.setUTCMonth(until.getUTCMonth() + months);
  const last = new Date(Date.UTC(until.getUTCFullYear(), until.getUTCMonth() + 1, 0)).getUTCDate();
  until.setUTCDate(Math.min(day, last));
  return until;
}
